import Icon from 'molecules/Icon';

import { ComparisonCellField } from 'components/Tables/Comparison/config';

import type { FC } from 'react';

const ComparisonTableCell: FC<ComparisonCellField> = ({ cell, text }) => {
  switch (cell) {
    case 'text':
      return (
        <div className="flex justify-center">
          <span className="text-center text-sm text-gray-300">{text}</span>
        </div>
      );
    case 'check':
      return (
        <div className="flex justify-center">
          <Icon icon="circle-check-1" size={25} className="text-primary-300" />
          <span className="sr-only">Yes</span>
        </div>
      );
    case 'x':
      return (
        <div className="flex justify-center">
          <Icon icon="x-mark" size={25} className="text-gray-500" />
          <span className="sr-only">No</span>
        </div>
      );
    default:
      return null;
  }
};

export default ComparisonTableCell;
